// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"890":"css/admin-app.6666","1291":"css/app.6666"}[chunkId] + ".css";
};